/* ============================================================
   YOLÈTE — Boutique : filtres à facettes + tri
   Orientation "boucle bijou" (review V1) : la boucle est l'objet
   central. Facettes multi-valuées Finition (métal) + Collection,
   dérivées dans catalog-enrich.js. La largeur reste une info de
   compatibilité (tiges 25/40 mm), pas l'argument principal.
   ============================================================ */

/* ---------- Définition des facettes ---------- */
const FINISH_LABELS = window.FINISH_LABELS || {
  dore: 'Doré', 'vieil-or': 'Vieil or', argent: 'Argenté', 'vieil-argent': 'Vieil argent',
};
const COLLECTION_LABELS = window.COLLECTION_LABELS || {
  intemporelle: 'Intemporelles', bijou: 'Bijou', western: 'Western', jungle: 'Animalier',
  glitter: 'Glitter', emaillee: 'Émaillées', statement: 'Statement', 'black-list': 'Black List',
};
const COULEUR_LABELS = window.COULEUR_LABELS || {
  or: 'Or', argent: 'Argent', ivoire: 'Ivoire', noir: 'Noir', marron: 'Marron',
  havane: 'Havane',
};

const FACETS = [
  {
    key: 'type', title: 'Catégorie',
    order: ['boucle', 'tige', 'ceinture', 'sac', 'anse'],
    labels: { boucle: 'Boucles', tige: 'Tiges', ceinture: 'Ceintures', sac: 'Sacs', anse: 'Anses' },
  },
  {
    key: 'finish', field: 'finishes', title: 'Finition (métal)', multi: true,
    order: ['dore', 'vieil-or', 'argent', 'vieil-argent'],
    labels: FINISH_LABELS,
  },
  {
    key: 'collection', field: 'collections', title: 'Collection', multi: true,
    order: ['intemporelle', 'bijou', 'western', 'statement', 'jungle', 'emaillee', 'glitter', 'black-list'],
    labels: COLLECTION_LABELS,
  },
  {
    key: 'couleur', field: 'couleur', title: 'Couleur dominante', multi: true,
    order: ['or', 'argent', 'ivoire', 'noir', 'marron', 'havane'],
    labels: COULEUR_LABELS,
  },
  {
    key: 'width', title: 'Largeur compatible',
    format: v => `${v} mm`,
  },
];

/* Sélections booléennes (Nouveautés / Best-sellers) rendues comme des toggles */
const FLAGS = [
  { key: 'new', label: 'Nouveautés', pred: p => p.isNew },
  { key: 'best', label: 'Best-sellers', pred: p => p.bestseller },
];

const PRICE_RANGES = [
  { id: '0-50',   label: 'Moins de 50 €', test: p => p.price < 50 },
  { id: '50-100', label: '50 € à 100 €',  test: p => p.price >= 50 && p.price < 100 },
  { id: '100',    label: '100 € et plus', test: p => p.price >= 100 },
];

const SORTS = {
  featured:    { label: 'En vedette',        fn: (a, b) => typeRank(a) - typeRank(b) },
  'price-asc': { label: 'Prix croissant',    fn: (a, b) => a.price - b.price },
  'price-desc':{ label: 'Prix décroissant',  fn: (a, b) => b.price - a.price },
  name:        { label: 'Nom (A → Z)',       fn: (a, b) => a.name.localeCompare(b.name, 'fr') },
};
/* La boucle d'abord (objet désir), puis la tige (support), puis la ceinture */
const TYPE_ORDER = { boucle: 0, tige: 1, ceinture: 2, sac: 3, anse: 4 };
function typeRank(p) { return TYPE_ORDER[p.type] ?? 9; }

/* val(p, facet) : renvoie toujours un tableau de valeurs (facettes mono ET multi).
   facet.field permet de lire un champ de données différent du nom de paramètre URL
   (ex. clé 'finish' -> champ 'finishes'). */
function facetValues(p, facet) {
  const raw = p[facet.field || facet.key];
  if (facet.multi) return Array.isArray(raw) ? raw : [];
  return (raw === null || raw === undefined) ? [] : [String(raw)];
}

/* ---------- État (initialisé depuis l'URL) ---------- */
const selected = { type: new Set(), finish: new Set(), collection: new Set(), couleur: new Set(), width: new Set(), price: new Set(), new: new Set(), best: new Set() };
let sort = 'featured';
/* Recherche : ?q= sur le site, ou la route /search du thème Shopify. */
let searchQ = '';
function fold(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }

(function readURL() {
  const q = new URLSearchParams(location.search);
  for (const f of FACETS) (q.get(f.key) || '').split(',').filter(Boolean).forEach(v => selected[f.key].add(v));
  (q.get('price') || '').split(',').filter(Boolean).forEach(v => selected.price.add(v));
  if (q.get('new') === '1') selected.new.add('1');
  if (q.get('best') === '1') selected.best.add('1');
  if (SORTS[q.get('sort')]) sort = q.get('sort');
  /* Sur le thème Shopify, /collections/<handle> rend cette page : le type et la
     largeur arrivent par window.YOLETE_ROUTE (template collection.liquid). */
  const R = window.YOLETE_ROUTE;
  if (R && R.kind === 'produits' && !selected.type.size) {
    if (R.type) selected.type.add(R.type);
    if (R.collection) selected.collection.add(R.collection);
    /* largeur imposée par la collection (Boucles 40 mm, Ceintures fines 25 mm...) ;
       les autres n'en imposent pas, le menu au survol montrant les deux largeurs */
    if ((R.w === '25' || R.w === '40') && !selected.width.size) selected.width.add(R.w);
  }
  /* Toute autre collection Shopify (/collections/<handle>, liens du menu au survol) :
     la page montre les pièces rangées dans cette collection dans Shopify. */
  if (R && R.kind === 'produits' && Array.isArray(R.membres)) window.YOLETE_MEMBRES = new Set(R.membres);
  searchQ = fold(q.get('q') || (R && R.kind === 'search' ? R.q : '') || '').trim();
  /* Funnel largeur : 40 mm par défaut, sauf sur une recherche où l'on montre
     les deux largeurs (sinon une boucle 25 mm cherchée par son code disparaît).
     La maroquinerie n'a pas de largeur de boucle : forcer 40 mm viderait la
     page, puisque les sacs ont width null. */
  var sansLargeur = selected.type.size
    && [...selected.type].every(function (t) { return t === 'sac' || t === 'anse'; });
  /* Avec le menu au survol (common.js), pas de largeur par défaut :
     Boucles ou Ceintures dans le bandeau montrent le 25 et le 40 mm, le choix se fait
     dans le menu ou dans Filtrer (demande de Nathan, 30/09/2026). */
  if (!selected.width.size && !searchQ && !sansLargeur && !window.YOLETE_MENU_SURVOL) selected.width.add('40');
  window.YOLETE_SANS_LARGEUR = sansLargeur;
})();

/* Titre d'une collection Shopify : « BIJOUX » devient « Bijoux », un titre déjà
   écrit en minuscules (« Hiver 26 ») reste tel quel. */
function joliTitre(s) {
  s = String(s || '').trim();
  return s === s.toUpperCase() ? s.charAt(0) + s.slice(1).toLowerCase() : s;
}

/* ---------- Titre de page selon le contexte ---------- */
(function setHead() {
  const h1 = document.querySelector('.shop-titre, .page-head h1');
  const crumb = document.querySelector('.page-head .crumb span');
  /* La maroquinerie est une famille de deux types, le sac et l'anse : quand la
     sélection ne contient que ceux-là, la page parle de maroquinerie. */
  const types = [...selected.type];
  const maroq = types.length > 0 && types.every(function (x) { return x === 'sac' || x === 'anse'; });
  const t = maroq ? (types.length === 1 && types[0] === 'anse' ? 'anse' : 'sac')
    : selected.type.size === 1 ? types[0]
    : selected.new.size ? 'new' : selected.best.size ? 'best' : 'boucle';
  const MAP = { boucle: 'Nos boucles de ceinture', tige: 'Nos ceintures en cuir', ceinture: 'Nos ceintures', sac: 'Notre maroquinerie', anse: 'Nos anses amovibles', new: 'Nos nouveautés', best: 'Nos best-sellers' };
  const raw = (new URLSearchParams(location.search)).get('q')
    || (window.YOLETE_ROUTE && window.YOLETE_ROUTE.kind === 'search' ? window.YOLETE_ROUTE.q : '') || '';
  const titreCol = (window.YOLETE_ROUTE && window.YOLETE_ROUTE.titre) ? joliTitre(window.YOLETE_ROUTE.titre) : '';
  const label = searchQ ? `Résultats pour « ${String(raw).trim()} »` : (titreCol || MAP[t] || 'La boutique');
  if (h1) h1.textContent = label;
  if (crumb) crumb.textContent = label;
  if (searchQ) {
    document.title = label + ' · Yolète';
    const funnel = document.getElementById('widthFunnel');
    if (funnel) funnel.hidden = true;   /* une recherche couvre les deux largeurs */
    return;
  }
  const wSel = (typeof selected.width !== 'undefined' && selected.width && selected.width.size === 1) ? [...selected.width][0] : null;
  const wTxt = wSel ? ` ${wSel} mm` : '';
  const SEO = {
    boucle: [`Boucles de ceinture interchangeables${wTxt} · Yolète`, `Boucles bijoux interchangeables${wTxt} pour ceinture en cuir, dorées ou argentées, fabriquées pour Yolète. Une ceinture, plusieurs boucles.`],
    tige: [`Ceintures en cuir${wTxt} fabriquées en France · Yolète`, `Ceintures en cuir${wTxt} façonnées à la main dans le Cantal, à boucle interchangeable. Cuir lisse, python ou vintage, tailles 75 à 110.`],
    sac: ['Maroquinerie · Sacs en cuir façonnés en France · Yolète', 'Les sacs Yolète en cuir Vintage et Savane, façonnés dans le Cantal. Anses amovibles, boucles interchangeables, fermeture aimantée.'],
    anse: ['Anses amovibles en cuir · Bella 25 et Bella 40 · Yolète', 'Les anses Bella en cuir Vintage, largeur 25 ou 40 mm, à boucle interchangeable et longueur réglable. Adaptables sur tous nos sacs.'],
    new: ['Nouveautés · Ceintures et boucles · Yolète', 'Les nouvelles ceintures en cuir et boucles de ceinture Yolète.'],
    best: ['Best-sellers · Ceintures et boucles · Yolète', 'Les ceintures en cuir et boucles de ceinture les plus demandées chez Yolète.'],
  };
  const seo = titreCol ? [`${titreCol} · Yolète`, ''] : (SEO[t] || [`${label} · Yolète`, '']);
  if (typeof setSEO === 'function') setSEO(seo[0], seo[1]); else document.title = seo[0];
  /* La maroquinerie n'a pas de largeur de boucle : le choix 25/40 est masqué. */
  if (t === 'sac' || t === 'anse') {
    const funnel = document.getElementById('widthFunnel');
    if (funnel) funnel.hidden = true;
  }
  /* Le choix de largeur illustre ce qu'on regarde : deux boucles sur la page
     Boucles, deux cuirs sur la page Tiges. */
  const a25 = document.getElementById('wArt25'), a40 = document.getElementById('wArt40');
  if (a25 && a40 && t === 'tige') {
    a25.src = 'https://cdn.shopify.com/s/files/1/0790/8714/1213/files/cut__belts__preto-black-25.png';
    a40.src = 'https://cdn.shopify.com/s/files/1/0790/8714/1213/files/cut__belts__preto-black-40.png';
    document.getElementById('widthFunnel')?.classList.add('is-straps');
  }
})();

/* ---------- Filtrage ---------- */
function passesPrice(p) {
  if (!selected.price.size) return true;
  return [...selected.price].some(id => PRICE_RANGES.find(r => r.id === id)?.test(p));
}
/* exceptKey : ignore une facette (pour calculer les compteurs de cette facette) */
function matches(p, exceptKey) {
  if (window.YOLETE_MEMBRES && !window.YOLETE_MEMBRES.has(p.id)) return false;
  if (searchQ) {
    /* identifiant Shopify exclu pour les boucles : il ment (boucle-n213 = N214) */
    const hay = fold([p.name, p.type === 'boucle' ? '' : p.id, p.style, (p.collections || []).join(' '), TYPE_LABEL[p.type] || ''].join(' '));
    if (!searchQ.split(/\s+/).every(w => hay.indexOf(w) >= 0)) return false;
  }
  if (exceptKey !== 'new' && selected.new.size && !p.isNew) return false;
  if (exceptKey !== 'best' && selected.best.size && !p.bestseller) return false;
  for (const f of FACETS) {
    if (f.key === exceptKey) continue;
    const sel = selected[f.key];
    if (!sel.size) continue;
    const vals = facetValues(p, f);
    if (!vals.some(v => sel.has(v))) return false;
  }
  if (exceptKey !== 'price' && !passesPrice(p)) return false;
  return true;
}

/* ---------- Valeurs distinctes d'une facette ---------- */
function valuesFor(facet) {
  const set = new Set();
  PRODUCTS.forEach(p => facetValues(p, facet).forEach(v => set.add(v)));
  let vals = [...set];
  if (facet.order) vals.sort((a, b) => {
    const ia = facet.order.indexOf(a), ib = facet.order.indexOf(b);
    return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
  });
  else vals.sort((a, b) => {
    const na = Number(a), nb = Number(b);
    return (!isNaN(na) && !isNaN(nb)) ? na - nb : String(a).localeCompare(String(b), 'fr');
  });
  return vals;
}

/* ---------- Rendu de la barre latérale ---------- */
const facetGroups = document.getElementById('facetGroups');

function renderFacets() {
  let html = '';

  /* Sélection (Nouveautés / Best-sellers) en tête */
  let flagHtml = '';
  for (const flag of FLAGS) {
    const count = PRODUCTS.filter(p => flag.pred(p) && matches(p, flag.key)).length;
    const checked = selected[flag.key].has('1');
    if (!count && !checked) continue;
    flagHtml += `
      <label class="facet-opt${count === 0 && !checked ? ' disabled' : ''}">
        <input type="checkbox" data-group="${flag.key}" value="1" ${checked ? 'checked' : ''}>
        <span>${flag.label}</span>
        <span class="count">${count}</span>
      </label>`;
  }
  if (flagHtml) html += `<div class="facet-group"><h4>Sélection</h4>${flagHtml}</div>`;

  for (const facet of FACETS) {
    /* la largeur est pilotée par le funnel en haut, sauf avec le menu au survol
       (common.js) : les tuiles disparaissent, la largeur devient un filtre */
    if (facet.key === 'width' && !window.YOLETE_MENU_SURVOL) continue;
    const vals = valuesFor(facet);
    if (!vals.length) continue;
    html += `<div class="facet-group"><h4>${facet.title}</h4>`;
    for (const v of vals) {
      const val = String(v);
      const count = PRODUCTS.filter(p => facetValues(p, facet).includes(val) && matches(p, facet.key)).length;
      const label = facet.labels?.[val] || (facet.format ? facet.format(v) : val);
      const checked = selected[facet.key].has(val);
      html += `
        <label class="facet-opt${count === 0 && !checked ? ' disabled' : ''}">
          <input type="checkbox" data-group="${facet.key}" value="${val}" ${checked ? 'checked' : ''}>
          <span>${label}</span>
          <span class="count">${count}</span>
        </label>`;
    }
    html += `</div>`;
  }

  /* Prix */
  html += `<div class="facet-group"><h4>Prix</h4>`;
  for (const r of PRICE_RANGES) {
    const count = PRODUCTS.filter(p => r.test(p) && matches(p, 'price')).length;
    const checked = selected.price.has(r.id);
    html += `
      <label class="facet-opt${count === 0 && !checked ? ' disabled' : ''}">
        <input type="checkbox" data-group="price" value="${r.id}" ${checked ? 'checked' : ''}>
        <span>${r.label}</span>
        <span class="count">${count}</span>
      </label>`;
  }
  html += `</div>`;

  facetGroups.innerHTML = html;
}

/* ---------- Chips actifs ---------- */
function labelOf(group, val) {
  if (group === 'price') return PRICE_RANGES.find(r => r.id === val)?.label || val;
  if (group === 'new') return 'Nouveautés';
  if (group === 'best') return 'Best-sellers';
  const facet = FACETS.find(f => f.key === group);
  return facet?.labels?.[val] || (facet?.format ? facet.format(Number(val)) : val);
}

function renderChips() {
  const chips = document.getElementById('activeChips');
  const all = [];
  for (const group of Object.keys(selected)) {
    if (group === 'width' && !window.YOLETE_MENU_SURVOL) continue;   /* la largeur reste sur le funnel, pas en chip (sauf menu au survol) */
    /* un seul type : le titre de la page le dit déjà (« BOUCLES × » sous « Nos boucles
       de ceinture » prenait une ligne pour rien, 15 oct 2026) */
    if (group === 'type' && selected.type.size === 1) continue;
    for (const val of selected[group]) all.push({ group, val });
  }

  if (!all.length) { chips.innerHTML = ''; return; }
  chips.innerHTML =
    all.map(({ group, val }) =>
      `<span class="chip">${labelOf(group, val)}<button data-clear="${group}:${val}" aria-label="Retirer">×</button></span>`
    ).join('') +
    `<button class="chip-clear" id="clearAll">Tout effacer</button>`;
}

/* ---------- Rendu de la grille ---------- */
const boutiqueGrid = document.getElementById('boutiqueGrid');
const resultCount = document.getElementById('resultCount');

/* Pièces "bientôt" (photos dossier 40mm sans prix) compatibles avec les filtres actifs.
   On les montre pour les boucles 40 mm, hors filtres finition/couleur/prix/best. */
function comingSoonForShop() {
  if (typeof COMING_SOON === 'undefined' || !COMING_SOON.length) return [];
  if (selected.best.size) return [];
  if (selected.type.size && !selected.type.has('boucle')) return [];
  if (selected.width.size && !selected.width.has('40')) return [];
  if (selected.finish.size || selected.couleur.size || selected.price.size) return [];
  let s = COMING_SOON.slice();
  /* Le directeur ne veut QUE les boucles du dossier « Site internet produits ». */
  if (typeof FOLDER_BOUCLES !== 'undefined' && FOLDER_BOUCLES.length)
    s = s.filter(x => FOLDER_BOUCLES.indexOf((x.code || '').toUpperCase()) !== -1);
  if (selected.collection.size) s = s.filter(x => selected.collection.has(x.collection));
  return s;
}

function renderResults() {
  let list = PRODUCTS.filter(p => matches(p, null));
  /* Une carte par modèle : dédoublonne les boucles (N314, N314B, N314/25...)
     et les ceintures (PRETO black/brown/navy -> une carte, coloris cliquables). */
  if (typeof dedupeBoucles === 'function') {
    let boucles = dedupeBoucles(list.filter(p => p.type === 'boucle'));
    if (typeof inFolderBoucle === 'function') boucles = boucles.filter(inFolderBoucle);
    const ceintures = (typeof dedupeCeintures === 'function')
      ? dedupeCeintures(list.filter(p => p.type === 'ceinture'))
      : list.filter(p => p.type === 'ceinture');
    const tiges = (typeof dedupeTiges === 'function')
      ? dedupeTiges(list.filter(p => p.type === 'tige'))
      : list.filter(p => p.type === 'tige');
    const autres = list.filter(p => p.type !== 'boucle' && p.type !== 'ceinture' && p.type !== 'tige');
    list = [...boucles, ...ceintures, ...tiges, ...autres];
  }
  if (SORTS[sort].fn) list = [...list].sort(SORTS[sort].fn);
  /* les pièces épuisées restent visibles, mais après celles qu'on peut acheter */
  list = [...list.filter(p => p.available !== false), ...list.filter(p => p.available === false)];

  const soon = comingSoonForShop();
  const count = list.length + soon.length;
  resultCount.textContent = `${count} pièce${count > 1 ? 's' : ''}`;
  /* Tiges seules : classe grid-tiges (4 colonnes comme les boucles depuis le 15 oct 2026). */
  boutiqueGrid.classList.toggle('grid-tiges', selected.type.size === 1 && selected.type.has('tige'));
  boutiqueGrid.innerHTML = count
    ? list.map(cardHTML).join('') + soon.map(soonCardHTML).join('')
    : `<div class="empty-grid">Aucune pièce ne correspond à ces filtres.<br><button class="btn-line" id="emptyReset">Réinitialiser</button></div>`;
  observeReveals();
}

/* ---------- Synchronisation de l'URL ---------- */
function syncURL() {
  const q = new URLSearchParams();
  for (const group of Object.keys(selected)) {
    if (group === 'new') { if (selected.new.size) q.set('new', '1'); continue; }
    if (group === 'best') { if (selected.best.size) q.set('best', '1'); continue; }
    if (selected[group].size) q.set(group, [...selected[group]].join(','));
  }
  if (sort !== 'featured') q.set('sort', sort);
  /* Les paramètres de campagne (gclid de Google Ads, utm_, fbclid, gtm_debug de
     l'assistant de balises Google) restent dans l'adresse : sans eux, une vente
     ne se rattache plus à l'annonce cliquée. */
  new URLSearchParams(location.search).forEach((v, k) => { if (/^(utm_|gad_|gclid$|gbraid$|wbraid$|fbclid$|srsltid$|msclkid$|gtm_debug$|_gl$)/.test(k)) q.set(k, v); });
  const qs = q.toString();
  history.replaceState(null, '', qs ? `?${qs}` : location.pathname);
}

/* ---------- Funnel largeur (25 / 40 mm) ---------- */
const widthFunnel = document.getElementById('widthFunnel');
function renderFunnel() {
  if (!widthFunnel) return;
  widthFunnel.querySelectorAll('.wf-btn').forEach(b =>
    b.classList.toggle('active', selected.width.has(b.dataset.w)));
}
widthFunnel?.addEventListener('click', e => {
  const b = e.target.closest('.wf-btn');
  if (!b) return;
  selected.width.clear();
  selected.width.add(b.dataset.w);
  update();
});

/* ---------- Re-render global ---------- */
/* Filtre de finition actif : chaque carte montre la photo de cette finition.
   Avant, on filtrait « or » et une boucle vendue dans les deux gardait sa
   photo argentée, ce qui donnait l'impression d'un filtre cassé. */
function refletFinition() {
  if (selected.finish.size !== 1 || typeof finitionsDeLibelle !== 'function') return;
  const cible = [...selected.finish][0];
  boutiqueGrid.querySelectorAll('.card').forEach(card => {
    const pastilles = [...card.querySelectorAll('.card-swatches .sw')];
    if (pastilles.length < 2) return;
    const voulue = pastilles.find(d => finitionsDeLibelle((d.getAttribute('title') || '') + ' ' + (d.dataset.voption || '')).includes(cible));
    if (!voulue || voulue.classList.contains('active')) return;
    const im = card.querySelector('.card-media img');
    if (im && voulue.dataset.img) im.src = voulue.dataset.img;
    pastilles.forEach(d => d.classList.toggle('active', d === voulue));
  });
}

/* Finitions recalculées d'après les pastilles, avant le premier rendu. */
if (typeof window.recalculerFinitions === 'function') window.recalculerFinitions();

function update() {
  renderFunnel();
  renderFacets();
  renderChips();
  renderResults();
  refletFinition();
  syncURL();
}

/* ---------- Événements ---------- */
facetGroups.addEventListener('change', e => {
  const input = e.target.closest('input[type="checkbox"]');
  if (!input) return;
  const set = selected[input.dataset.group];
  input.checked ? set.add(input.value) : set.delete(input.value);
  update();
});

document.getElementById('activeChips').addEventListener('click', e => {
  const clr = e.target.closest('[data-clear]');
  if (clr) {
    const [group, val] = clr.dataset.clear.split(':');
    selected[group].delete(val);
    update();
  }
  if (e.target.id === 'clearAll') { toutEffacer(); update(); }
});

boutiqueGrid.addEventListener('click', e => {
  if (e.target.id === 'emptyReset') { toutEffacer(); update(); }
});
/* Le type de la page (Boucles, Ceintures…) n'a plus de pastille : « Tout effacer »
   le garde, sinon la page Boucles se mettrait à montrer aussi les ceintures. */
function toutEffacer() {
  Object.keys(selected).forEach(k => { if (!(k === 'type' && selected.type.size === 1)) selected[k].clear(); });
}

document.getElementById('sortSelect').addEventListener('change', e => { sort = e.target.value; update(); });

/* ---------- Tiroir filtres (mobile) ---------- */
const facetsAside = document.getElementById('facets');
const facetOverlay = document.getElementById('facetOverlay');
const openFacets = () => { facetsAside.classList.add('open'); facetOverlay.classList.add('open'); };
const closeFacets = () => { facetsAside.classList.remove('open'); facetOverlay.classList.remove('open'); };
document.getElementById('filterToggle').addEventListener('click', openFacets);
document.getElementById('facetClose').addEventListener('click', closeFacets);
facetOverlay.addEventListener('click', closeFacets);

/* ---------- Init ---------- */
document.getElementById('sortSelect').value = sort;
update();
